import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/app/about/components/AboutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ellanmobility/src/components/Header.tsx");
